import { render } from "./Graderadd.vue?vue&type=template&id=27e76a52&scoped=true"
import script from "./Graderadd.vue?vue&type=script&lang=js"
export * from "./Graderadd.vue?vue&type=script&lang=js"

import "./Graderadd.vue?vue&type=style&index=0&id=27e76a52&scoped=true&lang=scss"

import exportComponent from "D:\\peizhe_protal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27e76a52"]])

export default __exports__